import { AutoMap } from "@automapper/classes";


export class MPCADTO {
    @AutoMap()
    code!: string;
    @AutoMap()
    name!: string;
    @AutoMap()
    type!: number;
    @AutoMap()
    scolaMaterial!: string;
    quantity!: string;

}